import { Component, OnInit } from '@angular/core';
import { OAClient } from "../../../../models/oaclient";
import { AuthRESTService } from "../../../services/rest/auth-rest.service";
import Commons from "../../commons";
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { SharedModule } from 'app/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule, AppWidgetModule],
    selector: 'app-oaclient-list',
    templateUrl: './oaclient-list.component.html',
    styleUrls: ['./oaclient-list.component.css']
})
export class OaclientListComponent extends Commons implements OnInit {
    clients: Array<OAClient>;
    clientsToDelete: string;

    constructor(private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
        super(toastr, translate)
    }

    ngOnInit(): void {
        this.rest.get('OAuth2/clients').subscribe((res) => {
            this.clients = res;
        }, err => this.errorHandler(err));
    }

    delete(clientId: string): void {
        this.rest.delete('OAuth2/client/' + clientId).subscribe((res) => {
            this.ngOnInit()
        }, err => this.errorHandler(err));
    }

}
